var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topBar"},[_vm._v("Faceted Search")]),_c('div',{staticClass:"content"},[_c('LiveDemo'),_c('markdown',{staticClass:"markdownStyle"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }